export const typography = {
  fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  
  h1: {
    fontSize: '32px',
    fontWeight: '700',
    lineHeight: '1.2',
    letterSpacing: '-0.02em',
  },
  h2: {
    fontSize: '24px',
    fontWeight: '600',
    lineHeight: '1.3',
    letterSpacing: '-0.01em',
  },
  h3: {
    fontSize: '18px',
    fontWeight: '600',
    lineHeight: '1.4',
  },
  body: {
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '1.5',
  },
  bodyBold: {
    fontSize: '14px',
    fontWeight: '600',
    lineHeight: '1.5',
  },
  caption: {
    fontSize: '12px',
    fontWeight: '400',
    lineHeight: '1.5',
    color: '#6B7280',
  },
  table: {
    fontSize: '13px',
    fontWeight: '400',
    lineHeight: '1.5',
  },
  tableHeader: {
    fontSize: '13px',
    fontWeight: '600',
    lineHeight: '1.5',
    textTransform: 'uppercase' as const,
    letterSpacing: '0.05em',
  }
};
